import React, {useEffect, useRef, useState} from "react";
import axios from "axios";
import {Link} from "react-router-dom";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

import {
    Bar,
    BarChart,
    CartesianGrid,
    Cell,
    Legend,
    Pie,
    PieChart,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis
} from "recharts";

import {baseUrl, userName} from "./Univ";

function Home() {

    const calendarRef = useRef();
    const getLocalDate = () => {
        const d = new Date();
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };
    const currentDate = new Date().toLocaleDateString("en-IN", {

        day: "2-digit",
        month: "long",
        year: "numeric"

    });
    const today = getLocalDate();

    const isAdmin = localStorage.getItem("userGroup") === "Admin";

    const [messview, setMessView] = useState([]);
    const [newsview, setNewsView] = useState([]);
    const [opData, setopData] = useState([]);

    const [labcount, setLabCount] = useState(0);
    const [labcount1, setLabCount1] = useState(0);
    const [mincount, setMinCount] = useState(0);

    const [invcount, setInvCount] = useState(0);
    const [invcount1, setInvCount1] = useState(0);

    const [ipdCount, setIpdCount] = useState(0);
    const [ipdTodayCount, setIpdTodayCount] = useState(0);
// COLLECTION STATES
    const [opCollection, setOpCollection] = useState([]);
    const [ipCollection, setIpCollection] = useState([]);
    const [refData, setRef] = useState([]);
    const [dueData, setDue] = useState([]);
    const [iprefData, setIpRef] = useState([]);

    const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#A28CFE", "#FF6666"];
    const [events, setEvents] = useState([]);

    async function fetchCollectionData() {

        try {

            const startDate = today;
            const endDate = today;

            const [
                opResponse,
                ipResponse,
                refResponse,
                dueResponse,
                iprefResponse
            ] = await Promise.all([

                axios.get(`${baseUrl}all-collection-view/?start_date=${startDate}&end_date=${endDate}&cashier=&mode=&status=2`),

                axios.get(`${baseUrl}all-ip-collection-view/?start_date=${startDate}&end_date=${endDate}&cashier=&mode=&status=2`),

                axios.get(`${baseUrl}refund-report-view/?start_date=${startDate}&end_date=${endDate}`),

                axios.get(`${baseUrl}due-report-view/?start_date=${startDate}&end_date=${endDate}`),

                axios.get(`${baseUrl}ip-refund-report-view/?start_date=${startDate}&end_date=${endDate}`)

            ]);

            setOpCollection(opResponse.data);
            setIpCollection(ipResponse.data);
            setRef(refResponse.data);
            setDue(dueResponse.data);
            setIpRef(iprefResponse.data);

        } catch (err) {
            console.log(err);
        }

    }

    useEffect(() => {

        fetchmessData();
        fetchnewsData();
        fetchOpData();
        fetchLabData();
        fetchMinData();
        fetchInvData();
        fetchIpViewData();
        fetchEventsData();
        fetchCollectionData();

    }, []);
    let TotalCons = 0, TotalLab = 0, TotalInv = 0, TotalMin = 0;
    let TotalRef = 0, TotalDue = 0;
    let TotalAdv = 0, TotalIpLab = 0, TotalIpInv = 0, TotalIpRef = 0;

    opCollection.forEach(p => {
        TotalCons += Number(p.paid || 0);
        TotalLab += Number(p.lab_paid || 0);
        TotalInv += Number(p.inv_paid || 0);
        TotalMin += Number(p.min_paid || 0);
    });

    refData.forEach(p => TotalRef += Number(p.refund_amount || 0));
    dueData.forEach(p => TotalDue += Number(p.due_amount || 0));

    ipCollection.forEach(p => {
        TotalAdv += Number(p.paid || 0);
        TotalIpLab += Number(p.lab_paid || 0);
        TotalIpInv += Number(p.inv_paid || 0);
    });

    iprefData.forEach(p => TotalIpRef += Number(p.refund_amount || 0));

    function fetchOpData() {

        axios.get(baseUrl + "op-appointment-view/")
            .then(res => {

                const todayOpd = res.data.filter(r =>
                    r.appt_date === today
                );

                setopData(todayOpd);

            })
            .catch(err => console.log(err));

    }


    function fetchmessData() {

        axios.get(baseUrl + "view-mess/" + userName)
            .then(res => setMessView(res.data))
            .catch(err => console.log(err));

    }

    function fetchnewsData() {

        axios.get(baseUrl + "view-news/")
            .then(res => setNewsView(res.data))
            .catch(err => console.log(err));

    }


    function fetchLabData() {

        axios.get(`${baseUrl}lab-entry-view/${today}/`)
            .then(res => setLabCount(res.data.length));

        axios.get(`${baseUrl}ip-lab-entry-view/${today}/`)
            .then(res => setLabCount1(res.data.length));

    }
function fetchMinData() {

        axios.get(`${baseUrl}min-pay-view/${today}/`)
            .then(res => setMinCount(res.data.length));


    }

    function fetchInvData() {

        axios.get(`${baseUrl}inv-entry-view/${today}/`)
            .then(res => setInvCount(res.data.length));

        axios.get(`${baseUrl}ip-inv-entry-view/${today}/`)
            .then(res => setInvCount1(res.data.length));

    }


    function fetchIpViewData() {

        axios.get(`${baseUrl}view-ip/?status=2`)
            .then(res => {

                setIpdCount(res.data.length);

                const todayIpd = res.data.filter(r => {

                    return r.admit_date.substring(0, 10) === today;

                });
                setIpdTodayCount(todayIpd.length);

            });

    }


    async function fetchEventsData() {

        const res = await axios.get(`${baseUrl}op-appointment-view/`);

        const todayEvents = res.data.filter(e =>
            e.appt_date === today
        );

        const formattedEvents = todayEvents.map(event => {

            const datetime = event.appt_date + "T" + event.appt_time;

            return {

                id: event.id,
                title: event.cons__consultant + " - " + event.pat__patient,
                start: datetime

            }

        });

        setEvents(formattedEvents);

    }


    const opdCount = opData.length;

    const appointmentTypeCounts = opData.reduce((counts, appointment) => {

        if (appointment.type === "new") counts.new++;
        else if (appointment.type === "revisit") counts.revisit++;

        return counts;

    }, {new: 0, revisit: 0});


    return (

        <section className="container mt-4">

            <h3 className="text-center mb-4">
                MIS Dashboard - {currentDate}
            </h3>


            {/* KPI CARDS */}

            <div className="row">

                <DashboardCard title="OPD Today" value={opdCount} color="#007bff"/>
                <DashboardCard title="New Patients" value={appointmentTypeCounts.new} color="#28a745"/>
                <DashboardCard title="IPD Today" value={ipdTodayCount} color="#ffc107"/>
                <DashboardCard title="Total IPD" value={ipdCount} color="#dc3545"/>
                <DashboardCard title="Lab Tests" value={labcount + labcount1} color="#6f42c1"/>
                <DashboardCard title="Procedure" value={mincount} color="#20c997"/>

            </div>


            {/* CALENDAR + COMMUNICATION */}

            <div className="row mt-5 align-items-stretch">

                <div className="col-md-6">

                    <div className="card shadow h-100">

                        <div className="card-header bg-primary text-white">
                            Today's Appointments
                        </div>

                        <div className="card-body">

                            <FullCalendar
                                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                headerToolbar={{
                                    left: "prev,next today",
                                    center: "title",
                                    right: "dayGridMonth,timeGridWeek,timeGridDay"
                                }}
                                initialView="timeGridDay"
                                timeZone="Asia/Kolkata"
                                events={events}
                                ref={calendarRef}
                                height="520px"
                            />

                        </div>

                    </div>

                </div>


                <div className="col-md-6">

                    <div className="card shadow-lg h-100">

                        <div className="card-header bg-dark text-white">
                            Communication Center
                        </div>

                        <div className="card-body">

                            <div className="row">


                                {/* MESSAGES */}

                                <div className="col-md-6">

                                    <h6>Messages</h6>

                                    <div style={{height: 250, overflowY: "auto"}}>

                                        {messview.map((m, i) => (
                                            <div
                                                key={i}
                                                style={{
                                                    background: "#f8f9fa",
                                                    padding: "8px",
                                                    borderRadius: "8px",
                                                    marginBottom: "6px"
                                                }}
                                            >
                                                {m.message}
                                            </div>
                                        ))}

                                    </div>

                                    <Link to="/comp-mess/" className="btn btn-success btn-sm mt-2">
                                        Open Chat
                                    </Link>

                                </div>


                                {/* NEWS */}

                                <div className="col-md-6">

                                    <h6>Hospital News</h6>

                                    <div className="news-ticker-container" style={{height: 250}}>

                                        <div className="news-ticker-box">

                                            <div className="news-ticker">

                                                {newsview.map((n, i) => (
                                                    <div key={i} className="news-item">

                                                        <img
                                                            src={n.attachment}
                                                            alt="Thumbnail"
                                                            className="thumbnail"
                                                            style={{width: 70, height: 50}}
                                                        />

                                                        <div className="news-text ms-2">

                                                            <h6>{n.heading}</h6>

                                                            <p style={{fontSize: 12}}>
                                                                {n.description}
                                                            </p>

                                                        </div>

                                                    </div>
                                                ))}

                                            </div>

                                        </div>

                                    </div>

                                </div>


                            </div>

                        </div>

                    </div>

                </div>

            </div>
            <div className="row mt-5">


                <div className="col-md-4">

                    <div className="card shadow">

                        <div className="card-header bg-info text-white">
                            OPD Distribution
                        </div>

                        <div className="card-body">

                            <ResponsiveContainer width="100%" height={300}>

                                <PieChart>

                                    <Pie
                                        data={[
                                            {name: "New", value: appointmentTypeCounts.new},
                                            {name: "Revisit", value: appointmentTypeCounts.revisit}
                                        ]}
                                        dataKey="value"
                                        outerRadius={90}
                                        label
                                    >

                                        <Cell fill="#0088FE"/>
                                        <Cell fill="#FF8042"/>

                                    </Pie>

                                    <Tooltip/>
                                    <Legend/>

                                </PieChart>

                            </ResponsiveContainer>

                        </div>

                    </div>

                </div>


                <div className="col-md-4">

                    <div className="card shadow">

                        <div className="card-header bg-success text-white">
                            Diagnostics
                        </div>

                        <div className="card-body">

                            <ResponsiveContainer width="100%" height={300}>

                                <BarChart
                                    data={[
                                        {name: "Lab", value: labcount + labcount1},
                                        {name: "Procedure", value: mincount }
                                    ]}
                                >

                                    <CartesianGrid strokeDasharray="3 3"/>
                                    <XAxis dataKey="name"/>
                                    <YAxis/>
                                    <Tooltip/>

                                    <Bar dataKey="value" fill="#82ca9d"/>

                                </BarChart>

                            </ResponsiveContainer>

                        </div>

                    </div>

                </div>


                <div className="col-md-4">

                    <div className="card shadow">

                        <div className="card-header bg-warning">
                            Patient Flow
                        </div>

                        <div className="card-body">

                            <ResponsiveContainer width="100%" height={300}>

                                <PieChart>

                                    <Pie
                                        data={[
                                            {name: "OPD", value: opdCount},
                                            {name: "IPD", value: ipdCount}
                                        ]}
                                        dataKey="value"
                                        outerRadius={90}
                                        label
                                    >

                                        <Cell fill="#00C49F"/>
                                        <Cell fill="#FFBB28"/>

                                    </Pie>

                                    <Tooltip/>
                                    <Legend/>

                                </PieChart>

                            </ResponsiveContainer>

                        </div>

                    </div>

                </div>

            </div>
            {isAdmin && (

                <div className="row mt-5">

                    {/* OP COLLECTION */}

                    <div className="col-md-6">

                        <div className="card shadow">

                            <div className="card-header bg-primary text-white">
                                OP Collection Today
                            </div>

                            <div className="card-body">

                                <ResponsiveContainer width="100%" height={350}>

                                    <PieChart>

                                        <Pie
                                            data={[
                                                {name: "Consult Fee", value: TotalCons},
                                                {name: "Lab", value: TotalLab},
                                                {name: "Radiology", value: TotalInv},
                                                {name: "Minor", value: TotalMin},
                                                {name: "Refund", value: TotalRef},
                                                {name: "Due Paid", value: TotalDue}
                                            ]}
                                            dataKey="value"
                                            outerRadius={120}
                                            label
                                        >

                                            {[TotalCons, TotalLab, TotalInv, TotalMin, TotalRef, TotalDue].map((_, i) => (
                                                <Cell key={i} fill={COLORS[i % COLORS.length]}/>
                                            ))}

                                        </Pie>

                                        <Tooltip/>
                                        <Legend/>

                                    </PieChart>

                                </ResponsiveContainer>

                            </div>

                        </div>

                    </div>


                    {/* IP COLLECTION */}

                    <div className="col-md-6">

                        <div className="card shadow">

                            <div className="card-header bg-success text-white">
                                IP Collection Today
                            </div>

                            <div className="card-body">

                                <ResponsiveContainer width="100%" height={350}>

                                    <PieChart>

                                        <Pie
                                            data={[
                                                {name: "Advance", value: TotalAdv},
                                                {name: "Lab", value: TotalIpLab},
                                                {name: "Radiology", value: TotalIpInv},
                                                {name: "Refund", value: TotalIpRef}
                                            ]}
                                            dataKey="value"
                                            outerRadius={120}
                                            label
                                        >

                                            {[TotalAdv, TotalIpLab, TotalIpInv, TotalIpRef].map((_, i) => (
                                                <Cell key={i} fill={COLORS[i % COLORS.length]}/>
                                            ))}

                                        </Pie>

                                        <Tooltip/>
                                        <Legend/>

                                    </PieChart>

                                </ResponsiveContainer>

                            </div>

                        </div>

                    </div>

                </div>

            )}

        </section>

    );

}


function DashboardCard({title, value, color}) {

    return (

        <div className="col-md-2 mb-3">

            <div
                style={{
                    background: "white",
                    borderRadius: "12px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                    padding: "15px",
                    borderLeft: `6px solid ${color}`
                }}
            >

                <h6 style={{color: "#555"}}>{title}</h6>
                <h3 style={{fontWeight: "bold"}}>{value}</h3>

            </div>

        </div>

    )

}

export default Home;